import http from "./httpService";
// import apiUrl from ".././config.json";
const apiUrl = require("../config.json").apiUrl;
const receiptapiUrl = require("../config.json").receiptapiUrl;

export const getBordingPass = (data) => {
    const apiEndPoint = `${apiUrl}/Boardingpass/UserId`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const generateBordingPass = (data) => {
    const apiEndPoint = `${apiUrl}/Boardingpass/BookingId`;
    return http.post(`${apiEndPoint}`,data);
  };

  
  export const generateBordingPassNext = (data) => {
    const apiEndPoint = `${apiUrl}/BoardPassNextBoat`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getDownloadReceipt = (data) => {
    const apiEndPoint = `${receiptapiUrl}/ReceiptDownload?BookingId=${data.BookingId}&BoatHouseId=${data.BoatHouseId}&BookingType=${data.BookingType}&EmailId=BoardingPass`;
    
      fetch(apiEndPoint)
          .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.blob();
          })
          .then(blob => {
              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.setAttribute('download', 'Boarding Pass.pdf'); 
              link.style.display = 'none'; 
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(blobUrl);
              link.remove();
          })
          .catch(error => console.error('Error downloading file:', error));
  
  
    return http.get(`${apiEndPoint}`);
  };